export default __webpack_public_path__ + "static/media/linkedin-icon-emBlue.23beeced.svg";